import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import CameraLiveStream from '../../pages/CameraLiveStream';
import CameraRecordedStream from '../../pages/CameraRecordedStream';
import CameraVideoWall from '../../pages/CameraVideoWall';
import NvStreamerFileUpload from '../../pages/nvstreamer/NvStreamerFileUpload';
import Debug from '../../pages/Debug';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 32;
const APP_BAR_DESKTOP = 46;

export const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

export const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} />

      <Nav openNav={open} onCloseNav={() => setOpen(false)} />

      <Main>
        {/** Streams is always mounted so that the video playback does not stop when route is changed. The Stream
         * component is made visible/invisible based on the current pathname in the URL. Making a compnenet visible does
         * not stops the video playback.
         */}
        <CameraLiveStream />
        <CameraRecordedStream />
        <CameraVideoWall />
        <Debug />
        <NvStreamerFileUpload />
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
